import { BreadcrumbsContext } from "./BreadcrumbsContext.js";
import React from "react";
//#region src/components/Breadcrumbs/useBreadcrumbsContext.ts
var useBreadcrumbsContext = () => {
	const context = React.useContext(BreadcrumbsContext);
	if (context === void 0) console.warn("useBreadcrumbsContext() must be a descendant of <BreadcrumbsContextProvider />");
	return context;
};
//#endregion
export { useBreadcrumbsContext };

//# sourceMappingURL=useBreadcrumbsContext.js.map